var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',_vm._g(_vm._b({attrs:{"name":"mediacontact-company-edit","toptitle":"Unternehmen bearbeiten","title":_vm.mediacontactCompany.name,"width":400}},'base-modal',_vm.$attrs,false),_vm.$listeners),[_c('mediacontact-company-form',{attrs:{"mediacontactCompany":_vm.mediacontactCompany,"type":"edit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }